import { isLocalUrl } from '../utils.js';

// Slide Template - Images (no widget-scope dependencies, kept at module scope)
function buildSlideTemplateImages(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>`;

  return template;
}

function buildSlideButtons(btn1, btn1Text, btn2, btn2Text) {
  if (btn1 || btn2) {
    let btnContainer = $('<div class="button-container"></div>');

    if (btn1) {
      const isLocalURL = isLocalUrl(btn1);
      btnContainer.append(
        `<a href="${btn1}"${isLocalURL ? '' : ' target="_blank"'} class="button">${btn1Text}</a>`,
      );
    }
    if (btn2) {
      const isLocalURL = isLocalUrl(btn2);
      btnContainer.append(
        `<a href="${btn2}"${isLocalURL ? '' : ' target="_blank"'} class="button">${btn2Text}</a>`,
      );
    }
    return btnContainer.prop('outerHTML');
  } else {
    return '';
  }
}

// Slide Template - Content (no widget-scope dependencies, kept at module scope)
function buildSlideTemplateContent(slide, _isFirstSlide) {
  let title;
  title = _isFirstSlide
    ? `<h1 class="slide-title">${slide.Title}</h1>`
    : `<h2 class="slide-title">${slide.Title}</h2>`;

  const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class='content-wrap ${!slide.URL && !slide.PurchaseURL ? 'no-btns' : ''}'>
          ${title}
          ${buildSlideButtons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
          </div>
        </div>
      </div>
    `;
  return template;
}

export default function mainSlider() {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>
    <div class="content-wraper">
     <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
      <div class="swiper-button-prev"></div>
          <div class="swiper-container swiper-container-content">
            <div class="swiper-wrapper"></div>
          </div>  
      <div class="swiper-button-next"></div>
    </div>
   
    `;

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide, index) {
      let isFirstSlide = index == 0;
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide, isFirstSlide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
